import { useCallback, Ref } from 'react';

export function mergeRefs<T>(...refs: Array<Ref<T>>): (node: T | null) => void {
  return useCallback(
    (node: T | null) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref != null) {
          (ref as React.MutableRefObject<T | null>).current = node;
        }
      });
    },
    [refs],
  );
}
